// import React, { useState, useRef, useEffect } from "react";

import NewItemRelocate from "../../../../components/@documents/item_relocates/NewItemRelocate"

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemRelocateNewPage() {

    return (
        <NewItemRelocate 
            routeType={routeTypes.workstation}
        />
    )
}